import { render, staticRenderFns } from "./MainMenuDefault.vue?vue&type=template&id=0b7b59b6"
import script from "./MainMenuDefault.vue?vue&type=script&lang=js"
export * from "./MainMenuDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports